export const URLS = {
  LOGIN: "/login",
  HOME: "/home",
  REQUESTER: "/requester",
  TEAM: "/teams",
  CHANNEL: "/channels",
  CUSTOMER: "/customer",
  CATEGORY: "/categories",
  MEMBER: "/members",
  DEPARTMENT: "/departments",
  TICKET: "/tickets",
  REPORTS: "/reports",
};
